import LabelInput from "./LabelInput";
import LabelSelectInput from "./LabelSelectInput";
// import LabelSwichInput from "./LabelSwichInput";
import { dateList, versionList } from "../../data/label";

export default function CertificatForm({
  searchHandler,
  formData,
  handleChange,
  intialisationHandler,
}) {
  return (
    <form
      onSubmit={searchHandler}
      className=" container mx-auto relative mb-10  gap-10  rounded-[5px]  w-full flex flex-col"
    >
      <div className=" flex flex-col md:flex-row w-[100%] md:w-[60%] gap-4 ">
        <div className="flex-1">
          <LabelSelectInput
            label="Organisme certificateur"
            options={[{ name: "CEISNA", id: 2 }]}
            defaultText={"Organisme certificateur"}
            setValue={(newCert) => handleChange("organisme", newCert)}
            value={formData.organisme}
          />
        </div>
        <div className="flex-1">
          <LabelInput
            name={formData.entityId}
            value={formData.entityId}
            onChange={(e) => handleChange("entityId", e.target.value)}
            label=" ID de l’entité certifiée"
          />
        </div>
      </div>
      <div className="flex flex-col md:flex-row w-[100%] md:w-[60%]   gap-4 ">
        <div className="flex-1">
          <LabelInput
            name={formData.entityName}
            value={formData.entityName}
            onChange={(e) => handleChange("entityName", e.target.value)}
            label="Nom de l’entité certifiée"
          />
        </div>
        <div className="flex-1">
          <LabelSelectInput
            label="Version du certificat"
            options={versionList}
            defaultText={"Version du certificat"}
            setValue={(newCert) => handleChange("version", newCert)}
            value={formData.version}
          />
        </div>
      </div>

      <div className=" w-full md:w-[60%]">
        <LabelInput
          name={formData.reference}
          value={formData.reference}
          onChange={(e) => handleChange("reference", e.target.value)}
          label="Référence de certification"
        />
      </div>

      <div className=" flex flex-col md:flex-row w-[100%] md:w-[90%] gap-4  ">
        <div className="flex-1">
          <LabelSelectInput
            label={"Date de début de validité"}
            options={dateList}
            defaultText={"Selectionner une date"}
            setValue={(newCert) => handleChange("startDate", newCert)}
            value={formData.startDate}
          />
        </div>
        <div className="flex-1">
          <LabelSelectInput
            label={"Date de fin de validité"}
            options={dateList}
            defaultText={"Selectionner une date"}
            value={formData.endDate}
            setValue={(newCert) => handleChange("endDate", newCert)}
          />
        </div>
      </div>

      <div className=" w-full md:w-[40%]">
        <LabelSelectInput
          label={"Statut"}
          options={[
            { name: "Actif", id: 1 },
            { name: "Encours de renouvellement", id: 2 },
            { name: "Expiré", id: 3 },
          ]}
          defaultText={"Selectionner"}
          setValue={(newCert) => handleChange("status", newCert)}
          value={formData.status}
        />
      </div>

      {/* <div className="md:col-span-2 lg:col-span-3 border-t pt-4">
        <LabelSwichInput
          enabled={formData.isHistory}
          onChange={(value) => handleChange("isHistory", value)}
          label={"Inclure version historique"}
        />
      </div> */}

      <div className="md:col-span-2 lg:col-span-3 flex items-center space-x-4">
        <button
          type="submit"
          className="px-6 py-2 bg-blue-800 text-white  hover:bg-blue-700 transition"
        >
          Rechercher
        </button>
        <button
          onClick={intialisationHandler}
          type="reset"
          className="text-blue-600 hover:underline"
        >
          Réinitialiser
        </button>
      </div>
    </form>
  );
}
